import { useStorage } from "@opendash/core";

export function useRideSearchTime() {
  return useStorage("device", "ride-sharing:search-time", "8:00");
}
